import { createBrowserRouter } from "react-router-dom";
import { GeoProtectedRoute } from "./components/geo-protected-route";
import { AppLayout } from "./pages/_layouts/app-layout";
import { NotFoundPage } from "./pages/404-page";
import { CameraPage } from "./pages/camera/camera";
import { QrCodeQuery } from "./pages/qrcode/qrcode-page";
import SealVerificationPage from "./pages/query/query-page";
import { LoginPage } from "./pages/sign-in/sign-in";
import { FaqPage } from "./pages/faq/faq-page";
import { DenunciarPage } from "./pages/denunciar/denunciar-page";
import { ContatoPage } from "./pages/contato/contato-page";
import ReadQRCodeTutorial from "./pages/tutorial/read-qrcode-tutorial";
import ErrorPage from "./errorPage";
import { TermsOfUsagePage } from "./pages/termos-de-uso/terms-of-usage";
import PrivacyPolicyPage from "./pages/politica-de-privacidade/privacy-policy-page";

export function createTenantRoutes() {
  const baseRoutes = [
    {
      path: "/",
      element: <AppLayout />,
      errorElement: <ErrorPage />,
      children: [
        {
          path: "/",
          element: <ContatoPage />,
        },
        {
          path: "/entrar",
          element: <LoginPage />,
        },
        {
          element: <GeoProtectedRoute />,
          children: [
            {
              path: "/selo/:hash",
              element: <QrCodeQuery />,
            },
            {
              path: "/consulta/:id",
              element: <SealVerificationPage />,
            },
            {
              path: "/camera",
              element: <CameraPage />,
            },
          ],
        },
        {
          path: "/tutorial/:query",
          element: <ReadQRCodeTutorial />,
        },
        {
          path: "/faq",
          element: <FaqPage />,
        },
        {
          path: "/denunciar",
          element: <DenunciarPage />,
        },
        {
          path: "/contato",
          element: <ContatoPage />,
        },
        {
          path: "/termos-de-uso",
          element: <TermsOfUsagePage />,
        },
        {
          path: "/politica-de-privacidade",
          element: <PrivacyPolicyPage />,
        },
      ],
    },
    // {
    // 	element: <ProtectedRoute />,
    // 	children: [
    // 	],
    {
      path: "/*",
      element: <NotFoundPage />,
    },
  ];

  return createBrowserRouter(baseRoutes);
}

export function getDefaultRoutes() {
  return createBrowserRouter([
    {
      path: "/",
      element: <AppLayout />,
      children: [
        {
          path: "/",
          element: <div>Configuração de produto não encontrada</div>,
        },
      ],
      errorElement: <ErrorPage />,
    },
  ]);
}
